import React from 'react';
import { FormProvider } from './context/FormContext';
import { PageLayout } from './components/layout/PageLayout';

function App() {
  return (
    <FormProvider>
      <PageLayout />
    </FormProvider>
  );
}

export default App;